import { Filters } from '../../_flux/constants/filter/filters';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import VehicleConfiguratorStore from '../../_flux/stores/vehicle_configurator_store';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { getAbsoluteValueForSpeedIndex } from '../../_modules/tyre_index/get_absolute_value_for_speed_index';
import { requestSetConfiguratorSource } from '../../_modules/requests/request_set_configurator_source';
import { hidePostcodeInvalidAction, showPostcodeInvalidAction, submitVehicleSelectorForm } from '../../_flux/actions/vehicle_configurator_actions';
import { types } from '../../_constants/product/types';
import { validatePostcode } from '../../validator/PostcodeAutocompleteValidator';
import { resetConfiguratorData } from '../configurator_buttons/configurator_buttons';
import {
    showAction as lockUi,
    hideAction as unlockUi
} from '../../_flux/actions/ui_lock_actions';

export function onConfiguratorSubmitFactory(tyreType) {
    return () => {
        const isVehicleDetails = location.pathname.indexOf('/checkout/') !== -1;
        const { values, postcodeSuggestion, touched } = VehicleConfiguratorStore.getState();
        if (
            values.postcode === '' ||
            (values.postcode && validatePostcode(TYROOLA.globals.store, values.postcode, postcodeSuggestion, touched))
        ) {
            lockUi();
            hidePostcodeInvalidAction();
            let tyreSize = values[Filters.VEHICLE_TYRES].split('|');
            let speedIndexAbsValue = getAbsoluteValueForSpeedIndex(tyreSize[5]);
            let filters = {
                [Filters.WIDTH]: tyreSize[0],
                [Filters.HEIGHT]: tyreSize[1],
                [Filters.DIAMETER]: tyreSize[2],
                [Filters.POSTCODE]: values.postcode,
            };

            if (tyreSize[4] && tyreSize[4].length > 0 && tyreSize[4] !== 'undefined') {
                filters[Filters.LOAD_INDEX] = parseInt(tyreSize[4]);
            }

            if (Number.isInteger(speedIndexAbsValue) && speedIndexAbsValue > 0) {
                filters[Filters.SPEED_INDEX] = speedIndexAbsValue;
            }

            updateFiltersAction(filters);

            submitVehicleSelectorForm();
            requestSetConfiguratorSource('vehicle_configurator')
                .then(() => {
                    if (!isVehicleDetails) {
                        applyFilters(types.TYRE_CAR, 'vehicle_configurator');
                    } else {
                        resetConfiguratorData();
                    }
                    unlockUi();
                })
                .done()
                .catch();
        } else {
            showPostcodeInvalidAction();
        }
    }
}
